module.exports = "/static/images/ARIA-DIRECT.jpg";